import { _get, _post } from "../CommonAxios";

const LoginToken = async (user) => {
    const loginUrl = "token/";
    let resp = null;
    let status = 1
    try {
        resp = await _post(loginUrl, user, {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(
            result => result.data);
        // if (tokenData) {
        //     
        //     return tokenData;
        // }
        status = 0
    } catch (error) {

    }
    return { status, resp };
}

const logoutToken = async () => {
    const logoutUrl = "token/logout/";
    try {
        await _post(logoutUrl, {}, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')

            }
        })
    } catch (error) {

    }
}

const refreshToken = async () => {
    const refreshUrl = "token/refresh/";
    let resp = null;
    try {
        resp = await _post(refreshUrl, {
            "refresh": localStorage.getItem('refresh_token')
        }, {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(
            result => result.data);
        if (resp) {
            localStorage.setItem('access_token', resp.access);
        }
    } catch (err) {

    }
    return resp
}

const checkNetwork = async () => {
    const healtUrl = "rsvp/guests/";
    let resp = null;
    try {
        resp = await _get(healtUrl)

    } catch (err) {

    }
    if (resp) {

        resp = true;
    }
    return resp
}


export { checkNetwork, LoginToken, logoutToken, refreshToken }